import { ListboxOption as FASTListboxOption } from '@microsoft/fast-components';
import { foundationListboxOptionStyles as styles } from './listbox-option.styles';
import { foundationListboxOptionTemplate as template } from './listbox-option.template';
/**
 * @tagname %%prefix%%-option
 */
export class ListboxOption extends FASTListboxOption {
}
// explicitly declaring for extensibility
export const foundationListboxOptionShadowOptions = undefined;
export const defaultListboxOptionConfig = {};
export const foundationListboxOption = ListboxOption.compose(Object.assign({ baseName: 'option', template,
    styles, shadowOptions: foundationListboxOptionShadowOptions }, defaultListboxOptionConfig));
